module.exports = __webpack_public_path__ + "img/seventh.c0bdaa3c.png";